import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import React from 'react'
import { FaCheckDouble } from 'react-icons/fa'
import CustomButton from '../../../../shared/CustomButton'
import { useTranslation } from 'react-i18next'
import CheckPermission from '../../../../hooks/CheckPermission'

const MarkInvoiceReturnedForm = ({
  handleMarkReturned,
  loading,
  selectedInvoiceData
}) => {
  const { hasPermission } = CheckPermission()
  const { t } = useTranslation()

  const initialValues = {
    return_reason: ''
  }

  const validationSchema = Yup.object().shape({
    return_reason: Yup.string().trim().required(t('Return reason is required'))
  })

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={values => {
          if (!hasPermission('billing', 'update')) return
          handleMarkReturned(values)
        }}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values
        }) => {
          return (
            <Form>
              <div className='flex flex-col gap-1 w-full mb-2'>
                <label className='input-label'>{t('Return Reason')} <span className='text-red-500'>*</span></label>
                <textarea
                  placeholder={t('Enter reason for marking this invoice as returned')}
                  className='w-full p-2 bg-gray-100 rounded-lg border border-gray-300 hover:border-primary !outline-none !shadow-none text-[14px]'
                  name='return_reason'
                  value={values.return_reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={4}
                />
                {errors.return_reason && touched.return_reason && (
                  <span className='text-sm text-red-500'>{errors.return_reason}</span>
                )}
              </div>

              {hasPermission('billing', 'update') && (
                <div className='flex justify-end gap-2'>
                <CustomButton
                  loading={loading}
                  type='submit'
                  icon={<FaCheckDouble size={12} className='me-2' />}
                  label={t('Mark as Returned')}
                  buttonType='primary'
                />
              </div>
              )}
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default MarkInvoiceReturnedForm
